import * as React from 'react';
import { Link } from "gatsby";
import { CountryBase } from "../../templates/fragments/country";
import { Region, RegionBase } from "../../templates/fragments/region";
import getLocationPath from "../../services/getLocationPath";
import { monthSlugsWithOverview } from '../../services/centralStore';
import Arrow from "../../images/ico_arrow_white.svg";
import { useLoc } from '../../hooks/useLoc';
import { Resort, ResortBase } from '../../templates/fragments/resort';


export const Breadcrumbs = ({
    resort = null,
    region = null,
    country = null,
    continent = null,
    month
}: {
    resort?: ResortBase,
    region?: RegionBase,
    country?: CountryBase,
    continent?: string,
    month: string
}) => {
    const loc = useLoc();
    const isCountry = !!country;
    // defined for all exc continents, isCountry keep track if original was country
    country = country || region?.country || resort?.region.country;
    // defined for resort and region, we need to ask if resort is missing
    region = region || resort?.region;
    const continentKey = continent || country?.continent;
    const continentName = loc('common.continents.' + continentKey)
    const monthIndex = monthSlugsWithOverview.indexOf(month);


    return (

        <>
            <p className="absolute top-[12px] left-[16px] text-white/90 md:hidden">
                {continent &&
                    <MobileLink path="/" text="Home" />}
                {(isCountry || region?.isCountry) && !resort &&
                    <MobileLink path={`/${continentKey}-weather-climate/`} text={continentName} />}
                {(region && !region.isCountry && !resort) &&
                    <MobileLink path={getLocationPath({ location: country, isCountryInstance: true, monthIndex: monthIndex })} text={country.name} />}
                {resort &&
                    <MobileLink path={getLocationPath({ location: region, isCountryInstance: false, monthIndex })} text={region.name} />}
            </p>
            <ul className="absolute top-[24px] left-[40px] text-white mdmax:hidden inline-flex">
                <DesktopLink path="/" text="Home" active={false} />
                <DesktopLink path={`/${continentKey}-weather-climate/`} text={continentName} active={!!continent} />
                {!continent &&
                    <DesktopLink path={getLocationPath({ location: country, isCountryInstance: true, monthIndex: monthIndex })} text={country.name} active={isCountry || (!resort && region.isCountry)} />}
                {region && !region.isCountry &&
                    <DesktopLink path={getLocationPath({ location: region, isCountryInstance: false, monthIndex: monthIndex })} text={region.slugName || region.name} active={!resort} />}
                {resort &&
                    <DesktopLink path={getLocationPath({ location: resort, isCountryInstance: false, isResortInstance: true, monthIndex: monthIndex })} text={resort.name} active={true} />}
            </ul>
        </>


    )
}

const DesktopLink = ({ path, text, active }) => {
    return (
        <li className={`${!active ? "after:content-['/'] after:w-7 after:px-3 text-white/70" : 'text-white/90'}`}><Link className="text-sm tracking-wider" to={path}>{text}</Link></li>
    )
}

const MobileLink = ({ path, text }) => {
    return (
        <Link to={path} className='inline-flex text-sm underline items-baseline tracking-wide'>
            <img alt="" src={Arrow} className="rotate-90 mr-2" /><span>{text}</span>
        </Link>
    )
}